import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, skipWhile, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppConfiguration } from '../classes/configuration';
import { CONFIGURATION_URL } from '../common/constants';
import { LoggerService } from './logger.service';

const useImMemoryWebApi = !environment.production && environment.inMemoryWebApiEnabled;

@Injectable()
export class ConfigurationService {
  public configuration$: BehaviorSubject<AppConfiguration> = new BehaviorSubject(null);
  private url: string;

  constructor(private http: HttpClient, private logger: LoggerService) {
    if (useImMemoryWebApi) {
      this.url = 'assets/data/mock-data/configuration.json';
    } else {
      this.url = CONFIGURATION_URL;
    }
  }

  loadConfig(): any {
    return this.http.get<AppConfiguration>(this.url).toPromise().then(
      (result) => {
        this.updateConfiguration(<AppConfiguration>result);
      },
      (error) => this.logger.error(`Error getting configuration:`, error)
    );
  }

  updateConfiguration(data: AppConfiguration): void {
    this.configuration$.next(data);
  }

  getConfiguration(): Observable<AppConfiguration> {
    return this.configuration$.asObservable();
  }

  getHostApi(): Observable<string> {
    return this.getConfiguration().pipe(
      skipWhile((config: AppConfiguration) => !config),
      take(1),
      map((config: AppConfiguration) => config.HostApi)
    );
  }
}
